import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

import { useIsGranted } from '~/application/hooks';
import { router } from '../router';

export const AuthorizedOutlet = () => {
    const { pathname } = useLocation();

    const [permissions, setPermissions] = useState<string[] | undefined>();
    const isGranted = useIsGranted(permissions);

    useEffect(() => {
        setPermissions(
            router.state.matches.map(
                (match) => (match.route as any).permission
            ).filter(p => p !== undefined)
        );
    }, [pathname]);

    return isGranted ? <Outlet /> : null;
};
